import s from './ui.module.css';

export function Skeleton({ height, width = '100%' }: { height: number; width?: number | string }) {
  return <span className={s.skeleton} style={{ display: 'block', height, width }} aria-hidden="true" />;
}
